import { useParams } from "react-router-dom";
import { HAAR_RADIUS_GEMEINDEN } from "@/data/locationsData";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const RegionalAthletic = () => {
  const { locationSlug } = useParams<{ locationSlug: string }>();
  const loc = HAAR_RADIUS_GEMEINDEN.find(g => g.slug === locationSlug) || HAAR_RADIUS_GEMEINDEN[0];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title={`Athletik Training ${loc.name} | Performance Coaching | Valorform`}
        description={`Wissenschaftlich fundiertes Athletiktraining in ${loc.name} (${loc.postalCode}) für ambitionierte Sportler.`}
        path={`/athletic-training/${loc.slug}`}
      />
      <Navigation />
      <main className="container mx-auto max-w-4xl px-4 py-24 mt-10">
        <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6">
          Athletik Training für Athleten aus {loc.name}
        </h1>
        <p className="text-xl text-muted-foreground mb-12 leading-relaxed">
          Standard-Fitnesstraining bringt dich nicht weiter, wenn du im Wettkampf dominieren willst. Unser sportwissenschaftliches Athletiktraining ist perfekt optimiert für leistungsorientierte Sportler aus der Region {loc.name}.
        </p>
        <div className="text-center bg-accent/10 p-8 rounded-xl border border-accent/20">
          <h3 className="text-2xl font-bold mb-4">Bringe deine Performance auf das nächste Level</h3>
          <a href="/" className="inline-block bg-primary text-white font-bold px-8 py-3 rounded-lg shadow-md hover:bg-primary/90 transition-colors duration-200">Jetzt Leistungsanalyse buchen</a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RegionalAthletic;
